import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { LocalStorageEffects } from './local-storage.effects';

@NgModule({
  imports: [EffectsModule.forFeature([LocalStorageEffects])],
})
export class LocalStorageStoreModule {}
